import { Fragment } from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import styles from '@/styles/pages/center/breadCrumbs.module.scss';

function BreadCrumbs({ detail = {} }) {
  const router = useRouter();
  const { t } = useTranslation('pages');
  const breadCrumbsArr = router.pathname.split('/').filter((breadCrumbs) => breadCrumbs !== '');

  return (
    <div className={styles.breadCrumbs}>

      <div className={styles.crumb}><Link href="/">{t('home.header')}</Link></div>
      <div className={styles.arrow}>{'>'}</div>

      {breadCrumbsArr.map((breadCrumbs, index) => {
        let linkBuilder = '';
        let textBuilder = '';
        const match = breadCrumbs.match(/\[(.*?)\]/);

        if (match) {
          const newArray = breadCrumbsArr.map((item) => item.replace(match[0], router.query[match[1]]));
          linkBuilder = newArray.slice(0, index + 1).join('/');
          textBuilder = detail.title ? detail.title : router.query[match[1]];
        } else {
          linkBuilder = breadCrumbsArr.slice(0, index + 1).join('/');
          textBuilder = t(`${breadCrumbsArr.slice(0, index + 1).join('.')}.header`);
        }
        return (
          <Fragment key={breadCrumbs}>
            <div className={styles.crumb}><Link href={`/${linkBuilder}`}>{t(`${textBuilder}`)}</Link></div>
            <div className={styles.arrow}>{'>'}</div>
          </Fragment>
        );
      })}
    </div>
  );
}

BreadCrumbs.propTypes = {
  detail: PropTypes.instanceOf(Object),
};
BreadCrumbs.defaultProps = {
  detail: {},
};

export default BreadCrumbs;
